import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';

// Static background image
import staticBgSvg from './assets/static-bg.svg';

// Context
import { AuthProvider } from './contexts/AuthContext';

// Components
import { ProtectedRoute } from './components/app/ProtectedRoute';
import { BottomNav } from './components/app/BottomNav';
// GlobalWaves removed - not used

// Pages
import { WelcomePage } from './pages/WelcomePage';
import { DownloadPage } from './pages/DownloadPage';
import { AuthPage } from './pages/AuthPage';
import { TodayPage } from './pages/TodayPage';
import { LessonsPage } from './pages/LessonsPage';
import { NewLessonPage } from './pages/NewLessonPage';
import { LibraryPage } from './pages/LibraryPage';
import { PaywallPage } from './pages/PaywallPage';
import { ProfilePage } from './pages/ProfilePage';
import { LegalPage } from './pages/LegalPage';
import { AdminPage } from './pages/AdminPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { SubscriptionSuccessPage } from './pages/SubscriptionSuccessPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        {/* STATIC Background - no animations, just image */}
        <div className="po-bg">
          <img 
            src={staticBgSvg} 
            alt="" 
            aria-hidden="true"
            className="po-bg-static"
          />

          <div className="po-content">
            <Toaster position="top-center" richColors duration={4000} />
            <Routes>
              <Route path="/" element={<WelcomePage />} />
              <Route path="/welcome" element={<WelcomePage />} />
              <Route path="/download" element={<DownloadPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/today" element={<ProtectedRoute><TodayPage /></ProtectedRoute>} />
              <Route path="/lessons" element={<ProtectedRoute><LessonsPage /></ProtectedRoute>} />
              <Route path="/lesson/:dayNumber" element={<ProtectedRoute><NewLessonPage /></ProtectedRoute>} />
              <Route path="/library" element={<ProtectedRoute><LibraryPage /></ProtectedRoute>} />
              <Route path="/paywall" element={<ProtectedRoute><PaywallPage /></ProtectedRoute>} />
              <Route path="/subscription/success" element={<ProtectedRoute><SubscriptionSuccessPage /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="/legal/terms" element={<LegalPage type="terms" />} />
              <Route path="/legal/privacy" element={<LegalPage type="privacy" />} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <BottomNav />
          </div>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
